import React,{Component} from "react";
import {connect} from "react-redux";
import ProjectsTable from "./ProjectsTable";
import {removeProject,projectNewToggle} from '../../../store/actions'
import {projectRowDefination, projectTableHeaderDefination,projectNewRowCreateor} from "./dataDef";


class AssetSchemasTab extends Component{

  rowDefWithAddRow = rowDef => {
    const {schema,newProject} = this.props;
    if(schema){
      rowDef.push(projectNewRowCreateor(schema,newProject.name,rowDef.length))
    }
    return rowDef;
  };

  render(){
    const {
      schema,name,isOpen,
      isOpenTabIndexChange,projectsBySchemas,id,
      openModal,newProjectCreating,projectNewToggle,
    } = this.props;

    const projectTableHeaders = projectTableHeaderDefination((schema && schema) || []);
    let rowDef = projectRowDefination((projectsBySchemas && projectsBySchemas.results) || []);
    if(newProjectCreating){
      rowDef = this.rowDefWithAddRow(rowDef);
    }

    return (
      <React.Fragment>
        <div style={{display:'flex'}}>
          <i className={"fa " +  (isOpen ? "fa-angle-up " : "fa-angle-down ")} onClick={()=> {
            projectNewToggle(false);
            isOpenTabIndexChange(id,false)}
          }/>
          <p>Assets Schema {name}</p>
          {isOpen && <i onClick={openModal} className="fa fa-plus"/>}
        </div>
        {(isOpen &&  projectTableHeaders.length !== 0) &&
        <ProjectsTable
          asset_id={id}
          projectTableHeaders={projectTableHeaders}
          rowDef={rowDef}/>}
      </React.Fragment>
    )
  }
}

const mapStateToProps = state => {
    return{
      projectsBySchemas: state.projects.projectsBySchemas,
      newProjectCreating: state.projects.newProjectCreating,
      newProjectSchema: state.projects.newProjectSchema,
      newProject: state.projects.newProject,
      schema: state.schemas.schema,
    }
};
export default connect(mapStateToProps,{removeProject,projectNewToggle})(AssetSchemasTab);


// WEBPACK FOOTER //
// ./src/views/Projects/Projects/AssetSchemasTab.js